exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottomright {\r\n    position: fixed;\r\n    width: 33%;\r\n    bottom: 35px;\r\n    right: 10px;\r\n    z-index: 99;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/OTHERS/FirstmediaShowSchedule/src/app/notification/notification.component.css
// module id = ../../../../../src/app/notification/notification.component.css
// module chunks = main